import Highcharts from 'highcharts/highstock'

import { formatNumber } from '../utils/Number'
import { highchartsOptions } from './chart-options'

Highcharts.setOptions(highchartsOptions)

const create = (element) => {
    const parser = element.dataset.chartParser || 'normal'
    let options = {
        legend: false,
        type: 'area',
    }

    try {
        options = {
            ...options,
            ...JSON.parse(element.dataset.chartOptions),
        }
    } catch (e) {}

    const formatPoint = (point) => {
        // Průměr (#3652) má v multiselectu pseudo-id 0 → Highcharts mu defaultně přiřadí modrou
        // (colors[0]). V tooltip vynutíme stejnou černou jako má line v chart.
        const color = point.series.name === 'Průměr' ? '#000000' : point.color
        return `<span style="color: ${color}">${point.series.name}: </span> <b>${formatNumber(
            point.y,
        )}</b>`
    }

    let chartOptions = {
        chart: {
            renderTo: element,
            alignTicks: false,
            spacingBottom: options.legend ? 50 : 20,
            type: options.type,
            animation: false,
            height: options.legend ? 400 : 300,
            zooming: {
                mouseWheel: false,
            },
        },
        credits: {
            enabled: false,
        },
        colors: [
            '#4555FF',
            '#0DC1AE',
            '#F94D4D',
            '#FFAE41',
            '#24CB61',
            '#57BFFF',
            '#8B79FF',
            '#FF7848',
        ],
        rangeSelector: {
            enabled: false,
        },
        plotOptions: {
            column: {
                stacking: 'normal',
            },
            area: {
                pointInterval: 24 * 3600 * 1000,
            },
        },
        title: null,
        legend: {
            enabled: options.legend,
            align: 'center',
            borderWidth: 0,
            layout: 'horizontal',
            y: 35,
        },
        navigator: {
            enabled: false,
        },
        scrollbar: {
            enabled: false,
        },
        tooltip: {
            formatter: function () {
                let s = []

                s.push(`<b>${Highcharts.dateFormat('%d. %m. %Y', this.x)}</b>`)

                if (parser === 'categories') {
                    s.push(`Celkem: <b>${formatNumber(this.points[0].total)}</b>`)
                }

                this.points.forEach((point) => s.push(formatPoint(point)))

                return s.join('<br>')
            },
        },
        series: [],
        xAxis: {
            minRange: 24 * 3600 * 1000,
        },
        yAxis: [
            {
                opposite: false,
                min: 0,
                labels: {
                    align: 'right',
                },
            },
        ],
    }

    const data = JSON.parse(element.dataset.chartData)

    chartOptions.series = Object.entries(data)
        .reduce((series, [key, item]) => {
            Object.entries(item).forEach(([categoryId, value]) => {
                const index = parseInt(categoryId)
                if (!series[index]) {
                    // "Průměr" (#3652) — výrazná tlustá přerušovaná line, ať není přehlédnutelná mezi
                    // ostatními křivkami center.
                    const isAverage = value.name === 'Průměr'
                    series[index] = {
                        name: value.name,
                        data: [],
                        ...(isAverage ? { lineWidth: 1.5, dashStyle: 'ShortDash', zIndex: 100, marker: { enabled: false } } : {}),
                    }
                }
                series[index].data.push([parseInt(key) - 1 * 60 * 60 * 1000, value.value])
            })

            return series
        }, [])
        .filter(Boolean)

    new Highcharts.stockChart(chartOptions)

    const colorizeLines = () => {
        chartOptions.series.forEach((center,id) => {
            const chartLines = document.querySelectorAll(`.highcharts-series-${id}`)
            const centerName = center.name.replace(/\s/g, '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z]/g, '')
            chartLines.forEach(line => {
                line.style.setProperty('--center-color', `var(--${centerName}-color)`);
            })
        })
    }

    colorizeLines()

    element.addEventListener('mousemove', () => {
        const tooltipLabels = element.querySelectorAll('.highcharts-tooltip text tspan')

        tooltipLabels.forEach(label => {
            const centerName = label.textContent.replace(/\s/g, '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/.$/, '').replace(/[^a-z]/g, '')

            if (label.textContent.includes('Pr\u016fm\u011br')) {
                label.style.setProperty('--center-color', `var(--prumer-color)`)
                return
            }

            if(label.textContent.includes('Citypark')) {
                label.style.setProperty('--center-color', `var(--${centerName}-color)`);
            } else if (label.textContent.includes('Spektrum')) {
                label.style.setProperty('--center-color', `var(--${centerName}-color)`);
            } else if (label.textContent.includes('Hradec')) {
                label.style.setProperty('--center-color', `var(--${centerName}-color)`);
            } else if (label.textContent.includes('Královo')) {
                label.style.setProperty('--center-color', `var(--${centerName}-color)`);
            } else if (label.textContent.includes('Liberec')) {
                label.style.setProperty('--center-color', `var(--${centerName}-color)`);
            } else if (label.textContent.includes('Géčko')) {
                label.style.setProperty('--center-color', `var(--${centerName}-color)`);
            } else if (label.textContent.includes('Teplice')) {
                label.style.setProperty('--center-color', `var(--${centerName}-color)`);
            } else if (label.textContent.includes('Plzeň')) {
                label.style.setProperty('--center-color', `var(--${centerName}-color)`);
            } else if (label.textContent.includes('IGY')) {
                label.style.setProperty('--center-color', `var(--${centerName}-color)`);
            } else if (label.textContent.includes('Boleslav')) {
                label.style.setProperty('--center-color', `var(--${centerName}-color)`);
            } else if (label.textContent.includes('Fénix')) {
                label.style.setProperty('--center-color', `var(--${centerName}-color)`);
            } else if (label.textContent.includes('Bondy')) {
                label.style.setProperty('--center-color', `var(--${centerName}-color)`);
            } else if (label.textContent.includes('Kolín')) {
                label.style.setProperty('--center-color', `var(--${centerName}-color)`);
            } else if (label.textContent.includes('Quadrio')) {
                label.style.setProperty('--center-color', `var(--${centerName}-color)`);
            } else if (label.textContent.includes('Vivo')) {
                label.style.setProperty('--center-color', `var(--${centerName}-color)`);
            } else if (label.textContent.includes('STOP')) {
                label.style.setProperty('--center-color', `var(--${centerName}-color)`);
            }
        })
    })
}

$(document).on('dom:change', function (event) {
    event.target.querySelectorAll('.chart-stack-column').forEach(create)
})
document.querySelectorAll('.chart-stack-column').forEach(create)
